{
    "Device_Filter_SectionHeader": "Gerätetyp-Filterung",
    "Device_Filter_Dropdown_Label": "Gerätetyp",
    "NAME": "ReportsFilterDeviceFilter"
}